import { FieldInstruction, FormValues } from 'containers/FormBuilder'
import InputField from 'form/fieldComponents/InputField'
import { normalizeNameFormatFn as formatFn } from 'form/fields/utils/nameFieldUtils'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

function vehicleVinValidation(): (formValues: FormValues) => Yup.StringSchema {
    return (formValues) => {
        return Yup.string()
            .matches(
                /^(\w{17}|\w{12}|\w{7})$/,
                'VIN must be 7, 12, or 17 alphanumeric characters',
            )
            .required(FIELD_REQUIRED)
    }
}

export function createVehicleVinFieldWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'VIN / HIN',
            validator: vehicleVinValidation(),
            formatFn,
        },
    }
}

function vehicleMileageValidation(): (
    formValues: FormValues,
) => Yup.NumberSchema {
    return (formValues) => {
        return Yup.number()
            .required(FIELD_REQUIRED)
            .typeError('Mileage must be a number')
    }
}

export function createVehicleMileageFieldWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Mileage',
            validator: vehicleMileageValidation(),
        },
    }
}
